import useSWRImmutable from 'swr/immutable';
import EmployeesService from '@/services/EmployeesService';

const useEmployeeInvoicesGraphs = (data) => useSWRImmutable(
    ['employee-invoices-graphs', data.id],
    () => EmployeesService.getEmployeeInvociesGraphs(data.id),
);

export default useEmployeeInvoicesGraphs;
